var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveySubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3906 5.51921V20.8838C19.3906 22.5192 18.0649 23.8449 16.4295 23.8449H3.40067C1.7653 23.8449 0.439575 22.5192 0.439575 20.8838V3.11719C0.439575 1.48182 1.7653 0.156094 3.40067 0.156094H14.0275C14.1847 0.146122 14.3484 0.198544 14.4794 0.329552L19.2171 5.06731C19.3482 5.19832 19.4006 5.36198 19.3906 5.51921ZM13.4684 1.34053H3.40067C2.41945 1.34053 1.62401 2.13597 1.62401 3.11719V20.8838C1.62401 21.865 2.41945 22.6604 3.40067 22.6604H16.4295C17.4107 22.6604 18.2062 21.865 18.2062 20.8838V6.07829H14.0606C13.7336 6.07829 13.4684 5.81314 13.4684 5.48607V1.34053ZM14.6528 2.17806V4.89385H17.3686L14.6528 2.17806ZM9.91509 10.4679V18.5137C9.91509 18.8408 9.64994 19.1059 9.32287 19.1059C8.9958 19.1059 8.73065 18.8408 8.73065 18.5137V10.4679L6.18832 13.0103C5.95704 13.2416 5.58207 13.2416 5.35079 13.0103C5.11951 12.779 5.11951 12.404 5.35079 12.1728L8.90411 8.61944C9.13538 8.38816 9.51036 8.38816 9.74163 8.61944L13.295 12.1728C13.5262 12.404 13.5262 12.779 13.295 13.0103C13.0637 13.2416 12.6887 13.2416 12.4574 13.0103L9.91509 10.4679Z",
    fill: "#F9FCF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveySubmit);
export default __webpack_public_path__ + "static/media/survey_submit.122db212454a6564cdc954d3a61a7370.svg";
export { ForwardRef as ReactComponent };